export interface StoreStatusModel {
  sst_id: number;
  sst_name: string;
  sst_description: string;
}

export enum StoreStatusEnum {
  ACTIVE = 1,
  INACTIVE = 2,
  SUSPENDED = 3,
  PENDING = 4,
}

export interface StoreStatusConfig {
  statusId: StoreStatusEnum;
  name: string;
  color: string;
  severity: string;
}

export const STORE_STATUS_CONFIG: Record<StoreStatusEnum, StoreStatusConfig> = {
  [StoreStatusEnum.ACTIVE]: {
    statusId: StoreStatusEnum.ACTIVE,
    name: 'Activa',
    color: '#10b981',
    severity: 'success',
  },
  [StoreStatusEnum.INACTIVE]: {
    statusId: StoreStatusEnum.INACTIVE,
    name: 'Inactiva',
    color: '#6b7280',
    severity: 'secondary',
  },
  [StoreStatusEnum.SUSPENDED]: {
    statusId: StoreStatusEnum.SUSPENDED,
    name: 'Suspendida',
    color: '#ef4444',
    severity: 'danger',
  },
  [StoreStatusEnum.PENDING]: {
    statusId: StoreStatusEnum.PENDING,
    name: 'Pendiente',
    color: '#f59e0b',
    severity: 'warning',
  },
};
